import React from 'react'
import ERROR404 from 'assets/images/404.png'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const ErrorPage403 = () => {
    const { t } = useTranslation();

    return (
        <div className=" h-screen flex  justify-center items-center ">
            <div className='mr-8'>
                <img src={ERROR404} alt="" width='256px' />
            </div>
            <div className="flex-grow-0">
                <div className="my-2 text-blue-500 font-bold text-6xl">
                    403
                </div>
                <h1 className="my-2 text-gray-800 font-bold text-3xl">
                    {t('errors.403_title')}
                </h1>
                <p className="my-2 text-gray-800">
                    {t('errors.403_description')}
                </p>
                <div className='mt-4'>
                    <NavLink exact to='/'
                        className="sm:w-full lg:w-auto my-4 border rounded-full md py-2 px-8 text-center bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:ring-opacity-50">
                        {t('actions.back_home')}
                    </NavLink>
                </div>

            </div>
        </div>
    );
}

export default ErrorPage403;